import React from 'react';
import { Tooltip } from 'antd';
import SpiStreamsIco from '@icons/aiAlerts/newapp-version.svg';
import { TOOLTIP_LABEL_SPI_STREAMS } from '@utils/constants';
import { humanizeValue, getSpiText } from './utils';
import { SpiStreamList, SpiStreamBlock, SpiStreamsValue, SpiBlock, SpiBlockValues } from './styled';

function StreamList({ data, type }) {
  const { StreamingPerformanceIndex, SpiStreams } = data;
  const textStyle = (value) => {
    const styles = getSpiText(value);
    const spiStyle = { color: `${styles}` };
    return spiStyle;
  };

  return (
    <SpiStreamList>
      <SpiStreamBlock>
        <Tooltip placement="bottomLeft" title={TOOLTIP_LABEL_SPI_STREAMS}>
          <SpiStreamsIco />
        </Tooltip>
      </SpiStreamBlock>
      <SpiStreamsValue> {humanizeValue(SpiStreams)}</SpiStreamsValue>
      <SpiBlock>SPI</SpiBlock>
      {type === 'newVersion' ? (
        <SpiBlockValues style={textStyle(humanizeValue(StreamingPerformanceIndex))}>
          {' '}
          {humanizeValue(StreamingPerformanceIndex)}
        </SpiBlockValues>
      ) : (
        <SpiBlockValues> {humanizeValue(StreamingPerformanceIndex)}</SpiBlockValues>
      )}
    </SpiStreamList>
  );
}
export default StreamList;
